(() => {
  const init = () => {
    const slider = tns({
      container: '[data-social-reviews-list-desktop]',
      items: 1,
      axis: "vertical",
      nav: true,
      mouseDrag: true,
      swipeAngle: false,
      autoplay: true,
      autoplayTimeout: 8000,
      autoplayHoverPause: true,
      autoplayButtonOutput: false
    });

    const sliderMobile = tns({
      container: '[data-social-reviews-list-mobile]',
      items: 1,
      nav: false,
      mouseDrag: true,
      swipeAngle: false,
      autoplay: true,
      autoplayTimeout: 8000,
      autoplayHoverPause: true,
      autoplayButtonOutput: false
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();